var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LeftNavigation',{attrs:{"leftNavDrawer":_vm.leftNavDrawer,"leftNavDrawerItems":_vm.leftNavDrawerItems}}),_c('Toolbar',{on:{"toolbarSideIconClick":function($event){_vm.leftNavDrawer = !_vm.leftNavDrawer}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }